import { UtcTime, ReportId } from 'types';
import * as moment from 'moment-timezone';

export type Params = {
    format: string;
    extension: string;
    reportId: ReportId;
    reportName: string;
    utcNow: UtcTime;
    tzOffsetCalculator: (t: UtcTime) => number;
    useUtc: boolean;
};

const regex = /%(rn|rid|YYYY|MM|DD|HH|hh|mm|ss|fff|tt)/g;

export const generateFileName = (params: Params): string => {
    const { format, extension, reportId, reportName, utcNow, tzOffsetCalculator, useUtc } = params;
    
    const m = moment.utc(utcNow);
    if (!useUtc) {
        m.utcOffset(tzOffsetCalculator(utcNow));
    }

    const state = {
        rn: reportName,
        rid: `${reportId}`,
        YYYY: m.format('YYYY'),
        MM: m.format('MM'),
        DD: m.format('DD'),
        HH: m.format('HH'),
        hh: m.format('hh'),
        mm: m.format('mm'),
        ss: m.format('ss'),
        fff: m.format('SSS'),
        tt: m.format('A'),
    };

    regex.lastIndex = 0;
    const filename = format.replace(regex, (s, key) => state[key]);
    return `${filename}.${extension}`;
};



// WEBPACK FOOTER //
// ./src/logic/reports/generateFileName.ts